<app-tab-grid
  i18n-name
  name="Printers"
  stateKey="UserPrinters"
  gridCssClass="user-printers"
  [columnDefs]="columnDefs"
  [rowData]="model$ | async"
  (create)="create()"
  (edit)="edit($event)"
  (delete)="delete($event)"
></app-tab-grid>
